import { tv } from "../../variants/tv.js";
const segmentedChipGroupVariants = tv({
    slots: {
        trackSlot: 'inline-flex rounded-full bg-neutral-2 p-1',
        shellSlot: 'relative inline-flex',
        groupSlot: 'relative min-w-[180px] gap-1',
        indicatorSlot: 'pointer-events-none absolute rounded-action-sm bg-primary-1 shadow-md transition-all duration-200 ease-out',
        chipOnTrackSlot: 'border-transparent bg-transparent shadow-none hover:border-transparent hover:bg-transparent hover:shadow-none active:border-transparent active:bg-transparent active:shadow-none aria-pressed:border-transparent aria-pressed:bg-transparent aria-pressed:shadow-none hover:aria-pressed:border-transparent hover:aria-pressed:bg-transparent hover:aria-pressed:shadow-none active:aria-pressed:border-transparent active:aria-pressed:bg-transparent active:aria-pressed:shadow-none [&_.material-symbols-icon]:shrink-0 [&_.material-symbols-icon>svg]:size-full'
    },
    variants: {
        fullWidth: {
            true: {
                trackSlot: 'flex w-full',
                shellSlot: 'flex w-full',
                groupSlot: 'w-full min-w-0 flex-nowrap',
                chipOnTrackSlot: 'min-w-0 flex-1 justify-center'
            }
        }
    },
    defaultVariants: {
        fullWidth: false
    }
});
export { segmentedChipGroupVariants };
